import React from 'react';
import styled from 'styled-components';
import Accordion from '../../Accordion';
import Graphic5 from './FairPriceApp/graphic5.svg';
import { SCREEN_SIZE } from '../../../lib/mediaQuery';

import {
  FAIR_PRICE_FIELD,
  CASHIER_FIELD,
  SELF_CHECKOUT_FIELD,
  StyledSubtitle,
  StyledTitle,
  StyledLine,
  StyledOrderedList,
  StyledImgWrapper,
} from './HowToRedeemViaFairPriceApp';

export const StyledText = styled.div`
  margin: 1rem 0 0;
  color: #333333;
  font-weight: 400;
  line-height: 1.5rem;
  ${SCREEN_SIZE.From.Tablet} {
    margin-left: 1rem;
  }
  ${SCREEN_SIZE.Below.Tablet} {
    text-align: center;
  }
`;

export const StyledMiddleLine = styled.div`
  .separator {
    display: flex;
    align-items: center;
    text-align: center;
  }

  .separator::before,
  .separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #eaeaea;
  }

  .separator:not(:empty)::before {
    margin-right: 0.25em;
  }

  .separator:not(:empty)::after {
    margin-left: 0.25em;
  }
`;

export const StyledSubContent = styled.div`
  ${SCREEN_SIZE.Below.Tablet} {
    text-align: center;
  }
`;

export const StyledSubTitleContent = styled.div`
  margin-top: 8px;
  min-height: 28px;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  ${SCREEN_SIZE.Below.Tablet} {
    text-align: center;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const HowToRedeemAccordion = () => {
  return (
    <Accordion title="How to redeem in stores">
      <FlexContainer>
        <StyledSubtitle id="title">Pay via the Fairprice Group app</StyledSubtitle>
        {FAIR_PRICE_FIELD.map(({ image, title, subTitle, titleContent }) => (
          <>
            <StyledImgWrapper>
              <img src={image.src} alt={image} height="160" width="160" loading="eager" />
              <StyledText id="counter-title">
                <StyledTitle>{title}</StyledTitle>
                <StyledSubTitleContent>{titleContent}</StyledSubTitleContent>
                <StyledSubContent>{subTitle}</StyledSubContent>
              </StyledText>
            </StyledImgWrapper>
          </>
        ))}

        <StyledMiddleLine>
          <div className="separator">Or</div>
        </StyledMiddleLine>

        <StyledImgWrapper>
          <img src={Graphic5.src} alt={Graphic5} height="160" width="160" loading="eager" />
          <StyledText>
            <StyledTitle />
            <StyledSubTitleContent>Manually enter Voucher code</StyledSubTitleContent>
            <StyledSubContent>
              Copy and paste or enter your code into the ‘Enter voucher code’ field and proceed to
              checkout
            </StyledSubContent>
          </StyledText>
        </StyledImgWrapper>
        <StyledLine />
        <StyledSubtitle id="title">At the cashier</StyledSubtitle>
        {CASHIER_FIELD.map(({ image, title, subTitle, titleContent }) => (
          <>
            <StyledImgWrapper>
              <img src={image.src} alt={image} height="160" width="160" loading="eager" />
              <StyledText id="counter-title">
                <StyledTitle>{title}</StyledTitle>
                <StyledSubTitleContent>{titleContent}</StyledSubTitleContent>
                <StyledSubContent>{subTitle}</StyledSubContent>
              </StyledText>
            </StyledImgWrapper>
          </>
        ))}
        <StyledLine />
        <StyledSubtitle id="title">At self-checkout counter</StyledSubtitle>
        {SELF_CHECKOUT_FIELD.map(({ image, title, subTitle }) => (
          <>
            <StyledImgWrapper>
              <img src={image.src} alt={image} height="160" width="160" loading="eager" />
              <StyledText id="counter-title">
                <StyledTitle>{title}</StyledTitle>
                {subTitle}
                <StyledOrderedList>
                  <ol>
                    <li>
                      Select <strong>All Other Payment</strong>
                    </li>
                    <li>
                      Select <strong>Partner Voucher / FP eVoucher</strong>
                    </li>
                    <li>Use the handheld scanner to scan the app QR code</li>
                  </ol>
                </StyledOrderedList>
              </StyledText>
            </StyledImgWrapper>
          </>
        ))}
      </FlexContainer>
    </Accordion>
  );
};

export default HowToRedeemAccordion;
